import { render, staticRenderFns } from "./task-adjust.vue?vue&type=template&id=47452790&scoped=true&"
import script from "./task-adjust.vue?vue&type=script&lang=js&"
export * from "./task-adjust.vue?vue&type=script&lang=js&"
import style0 from "./task-adjust.vue?vue&type=style&index=0&id=47452790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47452790",
  null
  
)

export default component.exports